import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setPackageData } from "../reducer/tourReducer";
import { usePackage } from "../hooks/usePackage";
import { addActiveTab } from "../reducer/sideBarSlice";
import { resetTourEdit } from "../reducer/tourEditReducer";

function TourManagementPackageDescriptionPage() {
  const [shorterror, setShortError] = useState("");
  const [fullerror, setFullError] = useState("");
  const [highlightsError, setHilightsError] = useState("");
  const [Error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { packageData, PrepackageDataId } = useSelector(
    (state: RootState) => state.tour
  );
  const { tourEdit, id } = useSelector((state: RootState) => state.edit);
  const progressref = useRef(2);

  const { createPrePackage } = usePackage();
  const [loading, setLoading] = useState(false);

  useOnLoadPage({ tabActive: "create" });

  useEffect(() => {
    if (location.state && location.state.packageData) {
      dispatch(setPackageData(location.state.packageData));
    }
  }, [location.state, dispatch]);

  const onContinue = () => {
    if (!packageData.shortDescription) {
      setShortError("Please enter the short decription of your package.");
      return;
    }
    if (!packageData.fullDescription) {
      setFullError("Please enter the full decription of your package.");
      return;
    }

    if (packageData.fullDescription.length < 500) {
      setFullError(
        "The full description must be at least 500 characters long."
      );
      return;
    }

    if (
      !packageData.highlights ||
      packageData.highlights.length < 3 ||
      packageData.highlights.some((hl) => !hl.trim())
    ) {
      setHilightsError("Please provide at least 3 non-empty highlight.");
      return;
    }

    setFullError("");
    setShortError("");
    setHilightsError("");
    dispatch(addActiveTab(Paths.tourManagementPackageLocation));

    navigate(Paths.tourManagementPackageLocation);
  };

  const onSave = async () => {
    if (!packageData.shortDescription) {
      setShortError("Please enter the short decription of your package.");
      return;
    }
    if (!packageData.fullDescription) {
      setFullError("Please enter the full decription of your package.");
      return;
    }

    if (packageData.fullDescription.length < 500) {
      setFullError(
        "The full description must be at least 500 characters long."
      );
      return;
    }

    if (
      !packageData.highlights ||
      packageData.highlights.length < 3 ||
      packageData.highlights.some((hl) => !hl.trim())
    ) {
      setHilightsError("Please provide at least 3 non-empty highlight.");
      return;
    }

    setFullError("");
    setShortError("");
    setHilightsError("");

    const updatedPackageData = {
      ...packageData,
      _id: PrepackageDataId,
      progress: Number(progressref.current),
    };

    const updatedPackageData2 = {
      ...packageData,
    };

    dispatch(setPackageData(updatedPackageData));
    setLoading(true);

    try {
      if (tourEdit) {
        dispatch(resetTourEdit());
        dispatch(setPackageData(updatedPackageData2));
        navigate(Paths.manageProductDetails.replace(":id", id), {
          state: { fromEdit: true },
        });
        return;
      } else {
        await createPrePackage(updatedPackageData);
      }

      localStorage.setItem("packageData", JSON.stringify(updatedPackageData));
      navigate(Paths.welcome);
    } catch (error) {
      console.error("Error saving package:", error);
      setError("Failed to save the package. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleHightlightChange = (e: any, index: number) => {
    let detail = packageData.highlights ? [...packageData.highlights] : [];
    detail[index] = e.target.value;

    dispatch(
      setPackageData({
        highlights: detail,
      })
    );

    if (highlightsError) setHilightsError("");
  };
  const handleAddHighlight = () => {
    let detail = packageData.highlights
      ? [...packageData.highlights, ""]
      : [""];
    dispatch(
      setPackageData({
        highlights: detail,
      })
    );
  };
  const handleRemoveHighlight = (index: number) => {
    const detail = packageData.highlights ? [...packageData.highlights] : [];
    detail.splice(index, 1);
    dispatch(
      setPackageData({
        highlights: detail,
      })
    );
    if (highlightsError && detail.length >= 3) setHilightsError("");
  };

  console.log("packageda", packageData);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageName);
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementSidebar selected={3} />

        <div className={Classname.detail}>
          <span className={Classname.title}>Introduce your package</span>
          <p className={Classname.description}>
            Give the customer a taste of what they’ll do in 2 or 3 sentences.
            This will be the first thing customers read after the title, and
            will inspire them to continue.
          </p>
          <textarea
            name=""
            id=""
            cols={30}
            rows={10}
            className={Classname.textarea}
            placeholder="Enter your details"
            value={packageData.shortDescription}
            onChange={(e) => {
              dispatch(
                setPackageData({
                  shortDescription: e.target.value,
                })
              );
              if (shorterror) setShortError("");
            }}
          />
          {shorterror && (
            <span className="mt-2 text-sm text-red-600">{shorterror}</span>
          )}

          <span className={Classname.title}>Add a full description</span>
          <p className={Classname.description}>
            Now, provide all the details about what the customer will see and
            experience during the activity, in the correct order. Bring the
            activity to life.
          </p>
          <textarea
            name=""
            id=""
            cols={30}
            rows={10}
            className={Classname.textarea}
            placeholder="Enter your details"
            value={packageData.fullDescription}
            onChange={(e) => {
              dispatch(
                setPackageData({
                  fullDescription: e.target.value,
                })
              );
              if (fullerror) setFullError("");
            }}
          />
          {fullerror && (
            <span className="mt-2 text-sm text-red-600">{fullerror}</span>
          )}
          <span className={Classname.title}>Summarize the highlights</span>
          <p className={Classname.description}>
            Write 3-5 sentences explaining what makes your activity special and
            stand out from the competition. Customers will use these to compare
            between different activities.
          </p>
          {packageData?.highlights?.map((hl, index) => (
            <div key={index} className="relative w-full flex items-center mt-2">
              <input
                type="text"
                placeholder={`Highlight ${index + 1}`}
                value={hl}
                onChange={(e) => handleHightlightChange(e, index)}
                className={`${Classname.input} pr-10 `} // Add padding-right for the remove button
              />
              <button
                className="absolute right-3 text-red-600 font-bold hover:text-red-800"
                onClick={() => handleRemoveHighlight(index)}
              >
                Remove
              </button>
            </div>
          ))}
          <span
            className={Classname.highlightButton}
            onClick={handleAddHighlight}
          >
            + Add more highlights
          </span>
          {highlightsError && (
            <span className="mt-2 text-sm text-red-600">{highlightsError}</span>
          )}

          <div className="flex justify-between items-center mt-10 w-full">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              {!tourEdit && (
                <button
                  className={Classname.continueButton}
                  onClick={onContinue}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageDescriptionPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 pr-20  ",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  highlightButton:
    "font-bold flex items-center gap-2 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
